import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-verify-details',
  templateUrl: './verify-details.component.html',
  styleUrls: ['./verify-details.component.css']
})
export class VerifyDetailsComponent implements OnInit {

  public token: any;
  public loanDetail: any = {};

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.activeRoute.data.subscribe((res: any) => {
      if (res.loanDetail && Object.keys(res.loanDetail).length) {
        this.loanDetail = res.loanDetail;
        this.token = this.loanDetail.token;
      }
    });
  }

  navigateToAccount() {
    this.router.navigateByUrl(`/loan/process/${this.token}/account`);
  }

}
